import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Step } from '@classes/step/step';
import { Role, StepUpdate, UserAdd } from '@classes/user/user-platform';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { RoleService } from '@services/role/role.service';
import { StepsService } from '@services/step/steps.service';
import { UsersService } from '@services/users/users.service';
import * as CryptoJS from 'crypto-js';

const reader = new FileReader();

@Component({
  selector: 'app-users-add',
  templateUrl: './users-add.component.html',
  styleUrls: ['./users-add.component.scss']
})
export class UsersAddComponent implements OnInit {
  faCamera = faCamera;

  addUserForm: FormGroup;
  inactive = true;
  confirmAdd = false;
  imgUserDefault = 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';

  roles: Role[];
  steps: Step[];
  color: ThemePalette = 'primary';
  stepsForUser: StepUpdate[] = [];
  // imagePictureBase64: string | ArrayBuffer = null;
  userAdd: UserAdd;
  imgUpload: File;

  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private usersService: UsersService,
    private authService: AuthService,
    private stepsService: StepsService
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.getSteps();
    this.getRoles();
  }

  onSubmit(): void {

    if (this.addUserForm.invalid) {
      this.inactive = true;
      return;
    }

    if (this.f.role.value === 'admin') {
      this.stepsForUser = null;
    }
    const hashedPassword = this.authService.cryptString(this.f.password.value)
    const roleUser = this.roles.find(item => item.name === this.f.role.value);

    const newUser: UserAdd = {
      username: this.f.username.value,
      lastname: this.f.lastname.value,
      firstname: this.f.firstname.value,
      role: roleUser,
      password: hashedPassword,
      steps: this.stepsForUser,
    };

    this.usersService.addUser(newUser).subscribe(res => {
      this.usersService.updatePhotoUser(res.id, this.imgUpload).subscribe(() => { });
      this.confirmAdd = true;
      setTimeout(() => {
        this.dialog.closeAll();
        this.confirmAdd = false;

      }, 2500);
    });
  }

  isInactive(valueInput: string): void {
    let inputValue = true;
    const regex = /^-?(0|[1-9]\d*)?$/;

    valueInput ? inputValue = true : inputValue = false;

    inputValue ? this.inactive = false : this.inactive = true;
  }

  addOrRemoveStep(step: Step): void {
    const indexStep = this.stepsForUser.findIndex(item => item.name === step.name);

    const convertStep: StepUpdate = {
      name: step.name,
      id: step.id
    };

    indexStep === -1 ?
      this.stepsForUser.push(convertStep) :
      this.stepsForUser.splice(indexStep, 1);


  }

  convertImage(event): void {
    this.imgUpload = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (res) => {
      this.imgUserDefault = res.target.result.toString();
    };
  }

  get f() {
    return this.addUserForm.controls;
  }

  private getSteps(): void {
    this.stepsService.getSteps().subscribe(res => {
      this.steps = res;
      // const form = document.getElementsByClassName('origin_step_category_inputs') as HTMLCollectionOf<HTMLElement>;

    });
  }

  private getRoles(): void {
    this.roleService.getRoles().subscribe(res => {
      this.roles = res;
    });
    this.f.role.setValue('user');
  }

  private initForm(): void {
    this.addUserForm = this.formBuilder.group({
      username: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      role: ['', Validators.required],
      password: ['', Validators.required],
      imgUser: [''],
    });
  }
}
